import React, { Component } from "react";

export default class UsersCell extends Component {
  onCheckChange = (e) => {
    this.props.toggleSelection(this.props.user);
  };

  deleteCallback = () => {
    this.props.removeFromSelected(this.props.user);
  };

  render() {
    var { username, email } = this.props.user;
    var { checked, selectedusers } = this.props;
    var style = { fontSize: 10, overflowWrap: "break-word", color: "#4da1ff" };

    return selectedusers === false ? (
      <label className="vertical-align-center custom-container-checkbox mb-3 pb-2 border-bottom w-full">
        <div>
          <div>{username}</div>
          <div style={style}>{email}</div>
        </div>
        <input
          type="checkbox"
          onChange={this.onCheckChange}
          checked={checked}
        />
        <span className="checkmark" />
      </label>
    ) : (
      <div className="vertical-align-center-justify-between mb-3 pb-2 border-bottom w-full ps-2">
        <div>
          <div className="custom-text1-primary-normal">{username}</div>
          <div style={style}>{email}</div>
        </div>
        <button
          className="btn btn-sm btn-delete modal-table-cross"
          onClick={this.deleteCallback}
        >
          X
        </button>
      </div>
    );
  }
}
